import { v4 as uuidv4 } from 'uuid';

export function SearchBar(props) {
	return {
		componentName: 'SearchBar',
		componentId: uuidv4(),
		props: Object.assign(
			{
				attemptPageTypeSearch: false,
				autocompleteAlignment: 'left',
				autocompleteFullWidth: false,
				blurOnSubmit: false,
				displayMode: 'search-button',
				emptyPlaceholder: 'Não encontramos nenhum resultado',
				openAutocompleteOnFocus: false,
				placeholder: 'O que você procura?',
				inputType: 'text',
				containerMode: 'overlay',
				disableBlurAndTouchEndHandler: false,
				maxWidth: '',
			},
			props,
		),
		childrenComponents: [],
	};
}
